import React, { useState, useEffect, useRef, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
// import PerfectScrollbar from 'react-perfect-scrollbar'
import {
   Box,
   Card,
   Container,
   Grid,
   Typography,
   Table,
   TableBody,
   TableCell,
   TableHead,
   TableRow,
   Divider,
   Button,
   TextField,
   Dialog,
   DialogTitle,
   DialogContent,
   DialogActions,
   Link
} from '@material-ui/core'
import PrintIcon from '@material-ui/icons/Print'

// components
import Loader from '../components/utils/Loader'
import CartProduct from '../components/fitting/CartProduct'
import MobileCartProduct from '../components/fitting/MobileCartProduct'
import logo from '../assets/images/logo.jpg'
import SearchResult from '../components/SearchResult'

// API
import { getPublicAPI, postPublicAPI, putPublicAPI } from '../api/index'

// contexts
import { ShoppingCartContext } from '../contexts/ShoppingCart'
import { ToastContext } from '../contexts/Toast'

import socket from '../components/Socket'
import * as Yup from 'yup'
import { Formik } from 'formik'
import { Link as RouterLink } from 'react-router-dom'

const Cart = () => {
   let mounted = useRef(true)
   const navigate = useNavigate()

   //    let customerId = localStorage.getItem('user_id')

   const { shopping, setShopping, searchC } = useContext(ShoppingCartContext)
   const { setToasts } = useContext(ToastContext)

   let total = 0

   const [loading, setLoading] = useState(true)
   const [products, setProducts] = useState([])
   const [order, setOrder] = useState(true)
   const [purchase, setPurchase] = useState('')
   const [open, setOpen] = useState(false)

   useEffect(() => {
      if (!localStorage.auth_token && !localStorage.ip_address) navigate('/login')

      return () => (mounted.current = false)
   }, [navigate])

   const handleClose = () => setOpen(false)

   const handleClickOpen = () => {
      if (localStorage.user_type === 'customer') onCheckout()
      else setOpen(true)
   }

   const onSubmit = async values => {
      console.log(values)
      try {
         let login = await getPublicAPI('/login', values)

         if (login?.success) {
            const { id, name, token, email, type, phone, address, company, picture, status } =
               login.data
            localStorage.setItem('user_id', id)
            localStorage.setItem('user_name', name)
            localStorage.setItem('auth_token', token)
            localStorage.setItem('user_email', email)
            localStorage.setItem('user_phone', phone)
            localStorage.setItem('user_address', address)
            localStorage.setItem('user_company', company)
            localStorage.setItem('user_type', type)
            localStorage.setItem('user_pic', picture)

            localStorage.setItem('user_status', status)
            if (status === 'Disabled') {
               localStorage.clear()
               navigate('/login', { replace: true })
               setToasts({
                  type: 'error',
                  messages: [{ msg: 'Account Disabled' }]
               })
            } else {
               setToasts({
                  type: 'success',
                  messages: [{ msg: 'Successful login' }]
               })
               handleClose()
               if (localStorage.user_type !== 'customer')
                  navigate('/app/dashboard', { replace: true })
               else navigate('/view-cart', { replace: true })
            }
         } else
            setToasts({
               type: 'error',
               messages: login?.errors
            })
      } catch (err) {
         setToasts({
            type: 'error',
            messages: [{ msg: `error in logging in ${err.message}` }]
         })
      }
   }

   useEffect(() => {
      const prepareCart = async () => {
         let data = { user: localStorage.user_email || localStorage.ip_address }
         let products = await getPublicAPI('/get-cart-products', data)

         if (products?.success) {
            products.data.length > 0 && setProducts(products.data)
            setToasts({
               type: 'info',
               messages: [{ msg: `Your cart is ready` }]
            })
         } else setToasts({ type: 'error', messages: products?.errors })
         setLoading(false)

         if (localStorage.user_type === 'customer') {
            let data = { user: localStorage.user_email, user2: localStorage.ip_address }

            let products1 = await putPublicAPI('/update-allcart-product', data)

            if (products1?.success) {
               products1.data.length > 0 && setProducts(products1.data)
               setToasts({
                  type: 'info',
                  messages: [{ msg: `Your cart is ready` }]
               })
            } else setToasts({ type: 'error', messages: products1?.errors })
            setLoading(false)
         }
      }
      prepareCart()
   }, [setToasts])

   const randomString = length => {
      let chars = '0123456789'

      let result = ''
      for (let i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)]
      return result
   }

   const setQuantity = async (product, quantity) => {
      let newProducts = []
      await Promise.all(
         products.map(prod => {
            if (prod.rhpn === product) prod.qty = quantity

            return newProducts.push(prod)
         })
      )

      setProducts(newProducts)
   }

   const setFeetsInches = async (product, feets, inches) => {
      let newProducts = []

      await Promise.all(
         products.map(prod => {
            if (prod.rhpn === product) prod.qty = feets + '-' + inches

            return newProducts.push(prod)
         })
      )

      setProducts(newProducts)
   }

   const onRemove = async product => {
      let newProducts = products.filter(prod => prod.rhpn !== product)
      setProducts(newProducts)

      let params = { user: localStorage.user_email || localStorage.ip_address, product }
      let removeProduct = await putPublicAPI('/remove-cart-product', params)

      if (removeProduct?.success) {
         setToasts({
            type: 'warn',
            messages: [{ msg: `${product} removed from cart` }]
         })

         setShopping(!shopping)
      } else setToasts({ type: 'error', messages: removeProduct?.errors })
   }

   const onCheckout = async () => {
      try {
         mounted.current && setOrder(false)

         let oNum = randomString(3) + '-' + randomString(7) + '-' + randomString(7)
         let productsData = []
         let totalAmount = total

         await Promise.all(
            products.map(async product => {
               // totalAmount += parseFloat((product.lPrice * product.qty).toFixed(2))

               let productInfo = {
                  pId: product.rhpn,
                  qty: product.qty,
                  type: product.type,
                  amount:
                     product.type === 'hose'
                        ? (
                           product.lPrice *
                           (parseInt(product.qty.split('-')[0]) +
                              parseInt(product.qty.split('-')[1]) / 12)
                        ).toFixed(2)
                        : parseFloat((product.lPrice * product.qty).toFixed(2))
               }

               productsData.push(productInfo)
            })
         )

         const data = {
            user: localStorage.user_email,
            products: productsData,
            totalAmount,
            oNum,
            purNum: purchase,
            datetime: new Date().getTime()
         }

         await postPublicAPI('/checkout', data)
         const obj = {}
         obj.user = localStorage.user_email
         obj.products = productsData
         obj.oNum = oNum
         obj.totalAmount = totalAmount
         socket.emit('addNotification', JSON.stringify(obj))
         setShopping(!shopping)
      } catch (err) {
         setToasts({
            type: 'error',
            messages: [{ msg: `error while checking out ${err.message}` }]
         })
      } finally {
         setTimeout(() => {
            mounted.current && setOrder(true)

            navigate('/app/orders')
         }, 1000)
      }
   }

   const printCart = divName => {
      let originalContents = document.body.innerHTML
      let originalTitle = document.title

      document.body.innerHTML = document.getElementById(divName).innerHTML
      document.title = 'Bill of materials'

      // window.print()
      try {
         // Print for Safari browser
         document.execCommand('print', false, null)
      } catch {
         window.print()
      }

      document.body.innerHTML = originalContents
      document.title = originalTitle

      window.location.reload()
   }

   let printTotal = 0
   return (
      <>
         <Helmet>
            <title>{loading ? 'Loading...' : 'Cart | The HosePod'}</title>
         </Helmet>
         <Dialog open={open} onClose={handleClose} aria-labelledby='form-dialog-title'>
            <DialogTitle id='form-dialog-title'>Sign in</DialogTitle>
            <DialogContent>
               <Formik
                  initialValues={{
                     email: 'manish@kumar.com',
                     password: 'Manish@01'
                  }}
                  validationSchema={Yup.object().shape({
                     email: Yup.string()
                        .email('Must be a valid email')
                        .max(255)
                        .required('Email is required'),
                     password: Yup.string().max(255).required('Password is required')
                  })}
                  onSubmit={onSubmit}
               >
                  {({
                     errors,
                     handleBlur,
                     handleChange,
                     handleSubmit,
                     isSubmitting,
                     touched,
                     values
                  }) => (
                     <form onSubmit={handleSubmit}>
                        <TextField
                           error={Boolean(touched.email && errors.email)}
                           fullWidth
                           helperText={touched.email && errors.email}
                           label='Email Address'
                           margin='normal'
                           name='email'
                           onBlur={handleBlur}
                           onChange={handleChange}
                           type='email'
                           value={values.email}
                           variant='outlined'
                        />
                        <TextField
                           error={Boolean(touched.password && errors.password)}
                           fullWidth
                           helperText={touched.password && errors.password}
                           label='Password'
                           margin='normal'
                           name='password'
                           onBlur={handleBlur}
                           onChange={handleChange}
                           type='password'
                           value={values.password}
                           variant='outlined'
                        />

                        <DialogActions>
                           <Button
                              color='primary'
                              disabled={isSubmitting}
                              fullWidth
                              size='large'
                              type='submit'
                              variant='contained'
                           >
                              Sign in now
                           </Button>
                        </DialogActions>
                     </form>
                  )}
               </Formik>
            </DialogContent>
            <DialogContent>
               <Typography color='textSecondary' variant='body1'>
                  <Link component={RouterLink} to='/reset-password' variant='h6'>
                     Forgot password?
                  </Link>
               </Typography>
               <Typography color='textSecondary' variant='body1'>
                  Don&apos;t have an account?{' '}
                  <Link component={RouterLink} to='/register' variant='h6'>
                     Sign up
                  </Link>
               </Typography>
            </DialogContent>
         </Dialog>

         <Box id='print-section'>
            <img
               style={{ width: '90px', height: '60px', float: 'left', pt: 5 }}
               src={logo}
               alt={'Hosepod Logo'}
            />
            <Box sx={{ pt: 3, pb: 3 }}>
               <Typography sx={{ ml: '35%' }} variant='h2'>
                  Bill of materials
               </Typography>
            </Box>
            <Box>
               <Divider />
            </Box>
            <Box sx={{ p: 1 }}>
               <Typography variant='h4'>{`Purchase #: ${purchase}`}</Typography>
            </Box>
            <Box sx={{ pb: 2 }}>
               <Divider />
            </Box>
            <Table>
               <TableHead>
                  <TableRow>
                     <TableCell>
                        <Typography sx={{ color: '#000', fontWeight: '500', fontSize: 2 }}>
                           Product
                        </Typography>
                     </TableCell>
                     <TableCell>
                        <Typography sx={{ color: '#000', fontWeight: '500', fontSize: 2 }}>
                           Quantity
                        </Typography>
                     </TableCell>
                     <TableCell>
                        <Typography sx={{ color: '#000', fontWeight: '500', fontSize: 2 }}>
                           Price
                        </Typography>
                     </TableCell>
                     <TableCell>
                        <Typography sx={{ color: '#000', fontWeight: '500', fontSize: 2 }}>
                           Subtotal
                        </Typography>
                     </TableCell>
                  </TableRow>
               </TableHead>
               <TableBody>
                  {products.map(product => {
                     printTotal += parseFloat(
                        product.type === 'hose'
                           ? (
                              product.lPrice *
                              (parseInt(product.qty.split('-')[0]) +
                                 parseInt(product.qty.split('-')[1]) / 12)
                           ).toFixed(2)
                           : (product.lPrice * product.qty).toFixed(2)
                     )

                     return (
                        <TableRow key={product._id}>
                           <TableCell>
                              <Typography sx={{ color: '#000', fontWeight: '500', fontSize: 2 }}>
                                 {product.rhpn}
                              </Typography>
                           </TableCell>
                           <TableCell>
                              <Typography sx={{ color: '#000', fontWeight: '500', fontSize: 2 }}>
                                 {product.type === 'hose'
                                    ? `${product.qty.split('-')[0]} feets ${product.qty.split('-')[1]
                                    } inches`
                                    : product.qty}
                              </Typography>
                           </TableCell>
                           <TableCell>
                              <Typography sx={{ color: '#000', fontWeight: '500', fontSize: 2 }}>
                                 {product.lPrice} / {product.type === 'hose' ? 'feet' : 'unit'}
                              </Typography>
                           </TableCell>
                           <TableCell>
                              <Typography sx={{ color: '#000', fontWeight: '500', fontSize: 2 }}>
                                 {product.type === 'hose'
                                    ? (
                                       product.lPrice *
                                       (parseInt(product.qty.split('-')[0]) +
                                          parseInt(product.qty.split('-')[1]) / 12)
                                    ).toFixed(2)
                                    : (product.lPrice * product.qty).toFixed(2)}
                              </Typography>
                           </TableCell>
                        </TableRow>
                     )
                  })}
                  <TableRow>
                     <TableCell>
                        <Typography sx={{ color: '#000', fontWeight: '500', fontSize: 3 }}>
                           TOTAL:
                        </Typography>
                     </TableCell>
                     <TableCell></TableCell>
                     <TableCell></TableCell>
                     <TableCell>
                        <Typography sx={{ color: '#000', fontWeight: '500', fontSize: 3 }}>
                           ${printTotal.toFixed(2)}
                        </Typography>
                     </TableCell>
                  </TableRow>
               </TableBody>
            </Table>
            <Box
               sx={{
                  position: 'absolute',
                  bottom: '2vh',
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  width: '100%'
               }}
            >
               <Typography sx={{ fontWeight: 'bold' }}>
                  Copyright @ The HosePod 2021 | All rights reserved
               </Typography>
            </Box>
         </Box>
         <Box
            sx={{
               backgroundColor: 'background.default',
               minHeight: '100%',
               py: 3
            }}
         >
            <Container maxWidth={false}>
               {loading ? (
                  <Loader />
               )
                  : searchC ?
                     (
                        <SearchResult />
                     )
                  : (
                  <>
                     <Grid sx={{ p: 5, flexDirection: 'column' }} container spacing={3}>
                        <Box
                           sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center'
                           }}
                        >
                           <Typography color='textPrimary' gutterBottom className='part-number'>
                              Shopping Cart
                           </Typography>
                           <Button
                              disabled={products.length === 0 || !purchase}
                              onClick={() => printCart('print-section')}
                              sx={{ p: 2, float: 'right', display: 'flex' }}
                           >
                              <PrintIcon fontSize='large' />
                              <Typography sx={{ pl: 1, textTransform: 'capitalize' }}>
                                 Bill
                              </Typography>
                           </Button>
                        </Box>
                        <Card sx={{ mt: 2 }}>
                           <Box className='cart-view'>
                              <Table>
                                 <TableHead>
                                    <TableRow>
                                       <TableCell>Product</TableCell>
                                       <TableCell>Quantity</TableCell>
                                       <TableCell>Price</TableCell>
                                       <TableCell>Sub Total</TableCell>
                                       <TableCell>Action</TableCell>
                                    </TableRow>
                                 </TableHead>
                                 <TableBody>
                                    {products.map(product => {
                                       total += parseFloat(
                                          product.type === 'hose'
                                             ? (
                                                product.lPrice *
                                                (parseInt(product.qty.split('-')[0]) +
                                                   parseInt(product.qty.split('-')[1]) / 12)
                                             ).toFixed(2)
                                             : (product.lPrice * product.qty).toFixed(2)
                                       )

                                       return (
                                          <CartProduct
                                             key={product._id}
                                             onRemove={onRemove}
                                             product={product}
                                             setQuantity={setQuantity}
                                             setFeetsInches={setFeetsInches}
                                          />
                                       )
                                    })}
                                 </TableBody>
                              </Table>
                           </Box>
                           <Box className='mobile-cart-view'>
                              {products.map(product => (
                                 <Box key={product._id}>
                                    <MobileCartProduct
                                       onRemove={onRemove}
                                       product={product}
                                       setQuantity={setQuantity}
                                       setFeetsInches={setFeetsInches}
                                    />
                                    <Divider />
                                 </Box>
                              ))}
                           </Box>
                           {products.length > 0 ? (
                              <>
                                 <Box
                                    className='checkout-container'
                                    sx={{ width: '40%', p: 2, float: 'left' }}
                                 >
                                    <TextField
                                       fullWidth
                                       helperText={'Purchase number is required*'}
                                       label='Purchase Number'
                                       margin='normal'
                                       name='purchaseNumber'
                                       onChange={e => setPurchase(e.target.value)}
                                       value={purchase}
                                    />
                                 </Box>
                                 <Box
                                    className='checkout-container'
                                    sx={{ width: '40%', p: 2, float: 'right' }}
                                 >
                                    <Box
                                       sx={{
                                          p: 1,
                                          display: 'flex',
                                          justifyContent: 'space-between'
                                       }}
                                    >
                                       <Typography>Shipping</Typography>
                                       <Typography>Estimate</Typography>
                                    </Box>
                                    <Box
                                       sx={{
                                          p: 1,
                                          display: 'flex',
                                          justifyContent: 'space-between'
                                       }}
                                    >
                                       <Typography sx={{ color: '#000', fontWeight: '500' }}>
                                          TOTAL:
                                       </Typography>
                                       <Typography sx={{ color: '#000', fontWeight: '500' }}>
                                          ${total.toFixed(2)}
                                       </Typography>
                                    </Box>
                                    <Box sx={{ pt: 2, pb: 2 }}>
                                       <Divider />
                                    </Box>
                                    <Box sx={{ pt: 2, pb: 3 }}>
                                       <Divider />
                                    </Box>
                                    <Button
                                       sx={{ width: '100%', p: 2, fontSize: 18 }}
                                       variant='contained'
                                       onClick={handleClickOpen}
                                       disabled={!order || products.length === 0 || !purchase || total ===0}
                                    >
                                       Checkout
                                    </Button>
                                 </Box>
                              </>
                           ) : (
                              <Box sx={{ p: 5 }}>
                                 <Typography
                                    sx={{
                                       fontWeight: '600',
                                       fontSize: '24px',
                                       textAlign: 'center'
                                    }}
                                 >
                                    Your cart is empty.
                                 </Typography>
                              </Box>
                           )}
                        </Card>
                     </Grid>
                  </>
               )}
            </Container>
         </Box>
      </>
   )
}

export default Cart